// Functionality to share product
const shareBtnWrapper = document.querySelector(".share-icon-wrapper");
const shareBtn = document.querySelector(".share-icon");
const shareWithBox = document.querySelector(".share-block");
const closeShare = document.querySelector(".close-share");
const wishlistIcon = document.querySelector(".wishlist-icon");

const productUrl = document.getElementById("p_copy_url");
const copyLink = document.querySelector(".copy-product-share-url");
const productContainer = document.querySelector(".product__info-container");
const toaster = document.querySelector(".share-toaster");
const closeCopyToast = document.querySelector(".close-toaster");

/**
 * Opens the share modal
 */
shareBtn.addEventListener("click", () => {
  shareBtnWrapper.classList.add("show");
  productContainer.style.position = "unset";
  wishlistIcon.classList.add("open");
  shareBtnWrapper.classList.add("open");
});

/**
 * Closes the share modal
 */
closeShare.addEventListener("click", () => {
  shareBtnWrapper.classList.remove("show");
  toaster.style.display = "none";
  productContainer.style.position = "sticky";
  wishlistIcon.classList.remove("open");
  shareBtnWrapper.classList.remove("open");
});

function updateToasterText(text) {
  var toastMessage = document.querySelector(".share-toaster .toast-message");
  toaster.style.display = "block";
  toastMessage.textContent = text;

  setTimeout(function () {
    toastMessage.textContent = "";
    toaster.style.display = "none";
  }, 3000);
}

/**
 * Attaches an event listener to the copy link button
 */
copyLink.addEventListener("click", function () {
  navigator.clipboard.writeText(productUrl.baseURI);
  updateToasterText("Link Copied");
});

closeCopyToast.addEventListener("click", () => {
  toaster.style.display = "none";
});
